import qs from 'query-string'
import {AuthOptions} from './AuthOptions'

export const redirectIfNeeded = () => {
    const params = {
        ...qs.parse(window.location.hash.split('?').pop()),
        ...qs.parse(window.location.search)
    }
    const options = new AuthOptions(params)

    const hasInputs = options.inputs().length === 0
    const hasOneProvider = options.providers() && options.providers().length === 1

    if (hasInputs && hasOneProvider) {
        window.location = options.providers()[0].link
        return true
    }

    return false
}